import { getSortedI18nNamespaces } from '@/lib/i18n/get-sorted-I18n-namespaces';

const i18nNamespaces = getSortedI18nNamespaces([
  'common',
  'home',
  'navigation',
]);

export type SiteFooterConfig = {
  i18nNamespaces: typeof i18nNamespaces;
};
export const siteFooterConfig: SiteFooterConfig = {
  i18nNamespaces,
};
